//Variables que son usados para los selectores de las opciones de los formularios de servicio de ambulancia 
export const opcionesTerapiaIntensiva = [
  "ORDINARIO COVID",
  "AEROPUERTO",
  "APOYO",
  "URGENCIA Z.I..",
  "COVID",
  "ESTUDIO FORÁNEO",
  "ESTUDIO",
  "COVID CONVENIO",
  "ESTUDIO Z.I",
  "ESTUDIO COVID",
  "ESTUDIO INCUBADORA",
  "EVENTO",
  "ORDINARIO FORÁNEO",
  "FORÁNEO EVENTO",
  "FORANEO COVID",
  "FORÁNEO TERAPIA INTENSIVA",
  "ESTUDIO TERAPIA INTENSIVA",
  "FORÁNEO TERAPIA INTERMEDIA",
  "SIMULACRO",
  "INCUBADORA",
  "RENTA DE UNIDAD",
  "ORDINARIO INFECTO-CONT",
  "ORDINARIO",
  "PSIQUIÁTRICO",
  "TER INT INCUBADORA",
  "TERAPIA INTENSIVA",
  "TERAPIA INTENSIVA COVID",
  "TERAPIA INTENSIVA ESTUDIO",
  "INCUBADORA INTERMEDIA FORANEO",
  "TERAPIA INTERMEDIA",
  "TERAPIA INTERMEDIA COVID",
  "TERAPIA INTERMEDIA ESTUDIO",
  "URGENCIA",
  "ESTUDIO TERAPIA INTERMEDIA",
  "ORDINARIO Z.I.",
  "ORDINARIO PROMOCION",
  "URGENCIA T.INTERMEDIA"
];

export const opcionesEstudioIdaVuelta = ["IDA", "VUELTA", "IDA Y VUELTA"];

export const opcionesTipoDisOxigeno = [
  "NINGUNO",
  "APOYO BVM",
  "PUNTAS DE ALTO FLUJO",
  "CPAP",
  "MASCARILLA SIMPLE",
  "MASCARILLA RESERVORIO",
  "PUNTAS",
  "TRAQUEOSTOMIA",
  "VENTILADOR",
  "MICRONEBULIZADOR",
  "BiPAP"
];

export const opcionesMercado = [
  "APOYO PARA BASE ORIENTE",
  "ASEGURADORA CONVENIO",
  "APOYO PARA AMBULANCIA",
  "EMPRESA CONVENIO",
  "HOSPITAL O CLINICA CONVENIO",
  "PÚBLICO",
  "PRIVADO",
  "TEC DE MONTERREY",
  "SOMME SANTÉ"
]

export const opcionesOrigen = [
  "CUMMINS ABO OFFICE",
  "AUTONEUM WTC",
  "ISSSTE",
  "ASISMED",
  "C DOCTORES",
  "C ANGELES SAUCITO",
  "BORGWARNER",
  "BOCAR/AUMA",
  "CENTRO DE ALTA ESPECIALIDAD EN REUMATOLOGÍA",
  "CME",
  "CREO",
  "ASILO",
  "C DEL PARQUE",
  "C NOYOLA",
  "C SOLEDAD",
  "CUMMINS MILLENIUM WAREHOUSE",
  "C LÁSER SOLUTIONS",
  "CUMMINS MOTORES EJE 122",
  "C POLANCO",
  "C SANTA CRUZ",
  "CONSULTORIO MEDICO",
  "C PERPETUO SOCORRO",
  "C SAN JOSÉ",
  "C UGO",
  "C SANTA ANA",
  "C SINAÍ",
  "C SANTA MÓNICA",
  "CONTINENTAL TIRE",
  "CREE",
  "C ZARATE",
  "CONSULTORIA MEDICO EMPRESARIAL CME",
  "CONSULTORIA MIABEL",
  "CUMMINS FILTRACIÓN",
  "CUMMINS GENERATOR TECHNOLOGIES",
  "CUMMINS EBU",
  "DIVERMETAL",
  "DAIKIN",
  "COLEGIO AGNES GONXA",
  "DOMICILIO",
  "DR BLANCO",
  "ESPECIALIDADES MEDICAS FAMILIA ZARATE",
  "EVENTO",
  "CASA DE MONEDA",
  "GASTROCLÍNICA",
  "GASTROENDOSCOPIA SAN LUIS",
  "GEA INTERNACIONAL ASEGURADORA",
  "GRUPO EURO",
  "GOODYEAR",
  "GR GABINETE RADIOLÓGICO",
  "GRUPO ACERERO (FITCE)",
  "GRUPO GUARPA",
  "H ANGELES SAUCITO",
  "H CENTRAL",
  "H CENTRO MÉDICO",
  "H DE LOS OLIVOS (TORRE MÉDICA)",
  "H EL NIÑO Y LA MUJER",
  "HGS",
  "H GENERAL DEL ISSSTE",
  "H BENEFICENCIA",
  "H LOMAS",
  "H MARCHARBEL",
  "H MILITAR",
  "H NUESTRA SEÑORA DE LOS ÁNGELES",
  "H OLIMED",
  "H SAUDE",
  "H STARMEDICA",
  "HEMS",
  "DRAXTON SASI",
  "HONEYWELL",
  "IGSA MEDICAL SERVICES",
  "IMSS",
  "LABORATORIO CHOPO",
  "LÁSER SAN LUIS S.A DE C.V",
  "MÉDICA BALCONES",
  "MÉDICA QUIRÚRGICA AMBULATORIA",
  "MÉDICA VIAL / CONSULMED",
  "MEDICENTRO DEL PARQUE",
  "NEFROLOGÍA Y DIÁLISIS DE SAN LUIS",
  "OTRO",
  "PLASTIGLAS DE MÉXICO",
  "PARQUE TANGAMANGA",
  "PACCAR PARTS (KENWORTH)",
  "PLASTIC TEC",
  "SEL MEDICA",
  "SALUD INTERACTIVA (MEDICAL HOME-MEDICA VRIM)",
  "SALUD OCUPACIONAL Y SERVICIOS PROFESIONALES S.C",
  "SASI (SERVICIOS Y ASESORIA EN SALUD INDUSTRIAL)",
  "H OLGA DE LA CONCEPCIÓN",
  "SOLUGLOB IKON",
  "SOMME SANTÉ",
  "SSI SHAEFFER S.A DE C.V",
  "SUACERO INDUSTRIAS",
  "SUACERO SOLEDAD",
  "TERNIUM",
  "TI AUTOMOTIVE",
  "TCM SLP",
  "TEC DE MONTERREY",
  "PLAZA DE TOROS",
  "UNIDAD QUIRÚRGICA AMBULATORIA CIRUGÍA PLÁSTICA Y ESTÉTICA",
  "URGENCIAS MÉDICO QUIRÚRGICAS SANTA ANA",
  "VITROMEX",
  "VÍA PÚBLICA",
  "WATCOM",
  "WATCO COMPANIES / TCM",
  "WELLDEX",
  "ZEZATI INTERNACIONAL",
  "ZOPPAS",
  "HOTEL",
  "MEXFAM",
  "C OLGA",
  "FAURECIA",
  "GM",
  "PLAZA COMERCIAL",
  "WTC 02",
  "EUROGAS",
  "AEROPUERTO",
  "ACERO PRIME",
  "HOSPITAL DE LAS AMERICAS",
  "HOME DEPOT",
  "CUMMINS MOTORES",
  "MUSASHI AUTO PARTS",
  "BIMBO",
  "COLEGIO ANDES",
  "ATMUS",
  "H ANGELES"
];

export const opcionesBaseOriente = [
  "EN TRAYECTO",
  "BASE ORIENTE",
  "GOODYEAR",
  "TARJETEO",
  "HEB",
  "CARR 57",
  "BASE CENTRAL",
  "DESDE OTRO TRASLADO",
  "EVENTO"
];